/*! @azure/msal-common v15.14.1 2026-01-17 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.14.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
